import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  GeoZoneBase,
  GeoZoneById,
  GeoZoneCreatePayload,
  GeoZoneUpdatePayload,
  GeoZoneItem,
  GeoZoneItemListParams,
  GeoZonePolygonListItem,
} from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/geo-zone`;

export const getItemList = async (params?: GeoZoneItemListParams): Promise<ApiResponse<GeoZoneItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<GeoZoneItem[]>>(`${BASE}/item-list`, { params });
  return data;
};

export const getPolygonList = async (): Promise<ApiResponse<GeoZonePolygonListItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<GeoZonePolygonListItem[]>>(`${BASE}/polygon-list`);
  return data;
};

export const getList = async (params?: RequestParams): Promise<ApiResponseList<GeoZoneBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<GeoZoneBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<GeoZoneById>> => {
  const { data } = await axiosInstance.get<ApiResponse<GeoZoneById>>(`${BASE}/show`, { params: { id } });
  return data;
};

export const create = async (payload: GeoZoneCreatePayload): Promise<ApiResponse<GeoZoneById>> => {
  const { data } = await axiosInstance.post<ApiResponse<GeoZoneById>>(`${BASE}/create`, payload);
  return data;
};

export const update = async (payload: GeoZoneUpdatePayload): Promise<ApiResponse<GeoZoneById>> => {
  const { data } = await axiosInstance.post<ApiResponse<GeoZoneById>>(`${BASE}/update`, payload);
  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/delete`, { id });
  return data;
};
